import request from '@/utils/request'
let ExpressApi = {
    /*订单列表*/
    orderlist(data) {
        return request._post('/shop/plus.express.index/index', data);
    },
    refreshOne(data) {
        return request._post('/shop/plus.express.index/refreshOne', data);
    },
    refreshExpressTrack(data) {
        return request._post('/shop/plus.express.index/refresh', data);
    },
    add(data) {
        return request._post('/shop/plus.express.index/add', data);
    },
    update(data) {
        return request._post('/shop/plus.express.index/update', data);
    },
    del(data) {
        return request._post('/shop/plus.express.index/del', data);
    },
     /*获取设置*/
     getSetting(data) {
        return request._get('/shop/plus.express.index/setting', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.express.index/setting', data);
    },
}

export default ExpressApi;



// WEBPACK FOOTER //
// ./src/api/express.js